import { GOOGLE_TOKEN_PATH, LIST_PROVIDER } from "./endpoint";
import schoolClient from "./school-axios-client";
const LoginService = {
  getListProvider: async () => {
    return schoolClient.get(LIST_PROVIDER);
  },
  getToken: async ({ access_token, state }) => {
    const data = {
      access_token: access_token,
      state: state,
    };
    return schoolClient.post(GOOGLE_TOKEN_PATH, data, {});
  },
};
export default LoginService;
